export default {"small-header-on-mobile":"HR4Vn","no-padding":"lqeeW"};